import "./style.scss";
import { useState } from "react";
import AOPConfig from "./AOPConfig/AOPConfig";
import AOPPrev from "./AOPPrev/AOPPrev";
import { AOPMaltaStudentData } from "@/src/types/admissionOffice";
import type { StudentLetterBasicCountry } from "./studentLetterBasicRegistry";

const emptyStudentState = (): AOPMaltaStudentData => ({
  currentDate: "",
  fullName: "",
  dateOfBirth: "",
  nationality: "",
  course: "",
  userOffice: "01",
  whose_doc: "",
  title: "",
  duration: "",
  mediumOfInstruction: "",
  passportNumber: "",
  academicYear: "",
  yearOfStudy: "",
  yearStudyMode: "",
  coursePrefix: "",
  bodyStudentLetter: [],
  secondBodyStudentLetter: null,
  secondPageDate: "",
  thirdBodyStudentLetter: null,
  file: null,
});

export interface AOPStudentLetterBasicLayoutProps {
  country: StudentLetterBasicCountry;
}

const AOPStudentLetterBasicLayout = ({ country }: AOPStudentLetterBasicLayoutProps) => {
  const [customize, setCustomize] = useState<boolean>(false);
  const [dataForGeneration, setDataForGeneration] = useState<AOPMaltaStudentData>(emptyStudentState);
  const [bodyForPrev, setBodyForPrev] = useState<AOPMaltaStudentData>(emptyStudentState);
  const [withQR, setWithQR] = useState(true);

  return (
    <div className="container admission-office-page">
      <AOPConfig
        country={country}
        dataForGeneration={dataForGeneration}
        setDataForGeneration={setDataForGeneration}
        setBodyForPrev={setBodyForPrev}
        setCustomize={setCustomize}
        setWithQRForPreview={setWithQR}
      />
      <AOPPrev country={country} bodyForPrev={bodyForPrev} customize={customize} withQR={withQR} />
    </div>
  );
};

export default AOPStudentLetterBasicLayout;
